




































import { defineComponent, onMounted, ref } from '@vue/composition-api'
import Button from '../components/parts/Button.vue'

export default defineComponent({
  name: 'Start',
  components: {
    Button,
  },
  setup() {
    const music = new Audio()
    const dialog = ref(false)
    music.volume = 0.2
    onMounted(() => {
      music.src = './sound/other_sound.mp3'
      music.load()
    })
    const switchDialog = () => {
      dialog.value = !dialog.value
      music.play()
    }
    return {
      dialog,
      play: () => {
        music.play()
      },
      switchDialog,
    }
  },
})
